<div [class.tier-header-wrapper]="isHeader">
  <app-tooltip-wrapper [noPadding]="true" [border]="'around'" [right]="!isHeader" [fullWidth]="isHeader" (click)="openStylePickerDialog()">
    <div [class.tier-header]="isHeader" [class.disabled]="!editable" class="tier-style {{ tierStyle }}">
      <div class="tier-header-label">
        @if (isTitle) {
          <h3 class="tier-header-title-label">
            {{ label }}
          </h3>
        } @else {
          {{ label }}
        }
      </div>

      @if ((displayable.displayOptions.active && hidden) || forceHidden) {
        <span class="icon icon-eye-blocked"></span>
      } @else if (!displayable.displayOptions.active) {
        <span class="icon icon-eye"></span>
      } @else if (cosmeticOptions) {
        @if (cosmeticOptions.highlight && cosmeticOptions.minimapIconShape) {
          <app-minimap-icon [cosmeticOptions]="cosmeticOptions"></app-minimap-icon>
        } @else if (cosmeticOptions && cosmeticOptions.highlight && cosmeticOptions.beam) {
          <app-highlight-beam-icon [highlightColor]="cosmeticOptions.highlightColor!"></app-highlight-beam-icon>
        } @else {
          <span class="icon icon-eye"></span>
        }
      }
      <ng-template #tooltip>
        <div class="label-background" [style.background-image]="labelBackgroundImage()">
          <div class="item-label">
            <div app-label-viewer [displayOptions]="displayable.displayOptions" [exampleName]="exampleName" [forceHidden]="forceHidden"
              [isCurrency]="isCurrency" [isWaystone]="isWaystone" [isDivinationCard]="isDivinationCard" [rarity]="rarity" [disableBackground]="true"
              [influence]="influence" [memoryStrands]="memoryStrands"></div>
          </div>
        </div>
      </ng-template>
    </div>
  </app-tooltip-wrapper>
</div>

@if (dialogOpen) {
  <app-style-picker-dialog
    (close)="closeStylePickerDialog()"
    (styleUpdated)="updateTierStyleAndTitle(); styleUpdated.emit();"
    [isCurrency]="isCurrency"
    [displayable]="displayable"
    [exampleName]="exampleName"
    [isWaystone]="isWaystone"
    [rarity]="rarity"
    [allowDisactivate]="allowDisactivate"
    [allowHide]="allowHide"
    [title]="styleDialogTitle"></app-style-picker-dialog>
}
